import { render, staticRenderFns } from "./ProductStoreReceipts.vue?vue&type=template&id=8dc90e30&scoped=true"
import script from "./ProductStoreReceipts.vue?vue&type=script&lang=js"
export * from "./ProductStoreReceipts.vue?vue&type=script&lang=js"
import style0 from "./ProductStoreReceipts.vue?vue&type=style&index=0&id=8dc90e30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc90e30",
  null
  
)

export default component.exports